import React, {Component, PureComponent} from "react";
import {Link} from "react-router-dom";
import {connect} from "react-redux";
import {toggleGlobalDopShow} from "../redux/actions/main";

class Breadcumbs extends Component {
	shouldComponentUpdate(nextProps) {
		return JSON.stringify(nextProps.data) !== JSON.stringify(this.props.data) || nextProps.isDopShow !== this.props.isDopShow;
	}

	render() {
		const {data, isDopShow, onToggleGlobalDopShow} = this.props;

		const breadcumbs = data.map((item, index) => {
			const link = (data.length > 2 && index === data.length - 1) ? item.key :
				<Link to={item.value}>{item.key}</Link>;

			return (
				<li key={`breadcumb-${index}`} className="breadcumbs__items__item">{link}</li>
			);
		});

		return (
			<div className="breadcumbs">
				<ul className="breadcumbs__items">
					{breadcumbs}
				</ul>
				<div className={`breadcumbs__dop ${isDopShow ? 'active' : ''}`} onClick={this.props.onToggleGlobalDopShow}>Доп.
					исходы
				</div>
			</div>
		);
	}
}

export default connect(
	state => ({
		isDopShow : state.main.isDopShow
	}),
	dispatch => ({
		onToggleGlobalDopShow : () => {
			dispatch(toggleGlobalDopShow());
		}
	})
)(Breadcumbs);


// WEBPACK FOOTER //
// ./src/app/components/Breadcumbs.js